import React, { useState } from "react";
import { fullName } from "../../lib/format";

export default function FamilyForm({ family, members, onSave, onClose }) {
  const [name, setName] = useState(family?.name || "");
  const [head, setHead] = useState(family?.head || "");
  const [sel, setSel]   = useState(family?.members || []);
  const toggle = (id) => setSel(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  return (
    <>
      <div className="modal-body">
        <div className="form-group mb-16">
          <label>Family Name *</label>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Johnson Family" />
        </div>
        <div className="form-group mb-16">
          <label>Family Head</label>
          <select value={head} onChange={e => setHead(e.target.value)}>
            <option value="">Select head</option>
            {members.map(m => <option key={m.id} value={m.id}>{fullName(m)}</option>)}
          </select>
        </div>
        <div className="form-section-title mb-12">Members in this Family</div>
        <div style={{ maxHeight: 240, overflowY: "auto" }}>
          {members.map(m => (
            <label key={m.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 0", cursor: "pointer", borderBottom: "1px solid var(--cream2)" }}>
              <input type="checkbox" checked={sel.includes(m.id)} onChange={() => toggle(m.id)} />
              <span style={{ fontSize: 13 }}>{fullName(m)}</span>
              <span className="badge badge-gray" style={{ marginLeft: "auto" }}>{m.maritalStatus}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={onClose}>Cancel</button>
        <button className="btn btn-gold" onClick={() => { if (!name) return; onSave({ ...family, id: family?.id, name, head, members: sel }); }}>Save Family</button>
      </div>
    </>
  );
}
